import {CSSObject} from 'styled-components'
import {LayoutProps} from '../'

/**
 * List of all shorthand props that we need to convert to css
 */

const layoutProps = {
  $p: 'padding',
  $m: 'margin',
  $px: ['paddingLeft', 'paddingRight'],
  $mx: ['marginLeft', 'marginRight'],
  $py: ['paddingTop', 'paddingBottom'],
  $my: ['marginTop', 'marginBottom'],
  $pt: 'paddingTop',
  $mt: 'marginTop',
  $pr: 'paddingRight',
  $mr: 'marginRight',
  $pb: 'paddingBottom',
  $mb: 'marginBottom',
  $pl: 'paddingLeft',
  $ml: 'marginLeft',
}

const convertLayoutProps = (values: LayoutProps): CSSObject =>
  Object.entries(layoutProps).reduce((acc, [key, cssProps]) => {
    const value = values[key]

    if (value === null || value === undefined) {
      return acc
    }

    if (Array.isArray(cssProps)) {
      cssProps.forEach((p: string) => {
        acc[p] = value
      })
    } else {
      acc[cssProps] = value
    }

    return acc
  }, {})

export default convertLayoutProps
